import { InsertAddress } from "@shared/dbSchemas";
import type { RootState } from "./index";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PropertySearchState {
  selectedProperty: {
    displayAddress: string;
    latitude: number;
    longitude: number;
    address: InsertAddress;
  } | null;
}

const initialState: PropertySearchState = {
  selectedProperty: null,
};

export const propertySearchSlice = createSlice({
  name: "propertySearch",
  initialState,
  reducers: {
    resetPropertySearch: (state) => {
      state.selectedProperty = null;
    },
    setSelectedProperty: (
      state,
      action: PayloadAction<PropertySearchState["selectedProperty"]>,
    ) => {
      state.selectedProperty = action.payload;
    },
  },
});

export const { resetPropertySearch, setSelectedProperty } =
  propertySearchSlice.actions;

export const selectProperty = (state: RootState) =>
  state.propertySearch.selectedProperty;

export default propertySearchSlice.reducer;
